import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { toast } from "sonner";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem("ukok-cart");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("ukok-cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantity = 1, selectedSize = null) => {
    setCart((prev) => {
      const existing = prev.find((item) =>
        item.id === product.id && item.selectedSize === selectedSize
      );
      if (existing) {
        return prev.map((item) =>
          item.id === product.id && item.selectedSize === selectedSize
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { ...product, quantity, selectedSize }];
    });
    toast.success(`${product.name}${selectedSize ? ` (${selectedSize})` : ""} added to cart`, {
      action: { label: "Checkout", onClick: () => window.location.href = "/checkout" }
    });
  };

  const removeFromCart = (productId, selectedSize = null) => {
    setCart((prev) => prev.filter((item) =>
      !(item.id === productId && item.selectedSize === selectedSize)
    ));
  };

  const updateQuantity = (productId, quantity, selectedSize = null) => {
    if (quantity < 1) { removeFromCart(productId, selectedSize); return; }
    setCart((prev) =>
      prev.map((item) =>
        item.id === productId && item.selectedSize === selectedSize
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => setCart([]);
  const cartTotal = cart.reduce((sum, item) => sum + item.selling_price * item.quantity, 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const value = useMemo(() => ({
    cart, addToCart, removeFromCart, updateQuantity, clearCart, cartTotal, cartCount
  }), [cart, cartTotal, cartCount]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
